import React from "react";
import styled from "@emotion/styled";

import TooltipComponent from "../tooltip/Tooltip";

export type BetaFeatureType = "frameworks" | "spendData" | "hybridSearch";

const betaFeatureContent = (BetaFeature: BetaFeatureType) => {
  switch (BetaFeature) {
    case "frameworks":
      return (
        <StyledTooltipContent>
          <StyledTooltipText>
            Frameworks is a beta feature. We are still working to ensure our data and feature
            completeness is at the standard required for a full release.
          </StyledTooltipText>
          <StyledTooltipText>
            Please reach out to our team if you have any questions or feedback.
          </StyledTooltipText>
        </StyledTooltipContent>
      );
    case "spendData":
      return (
        <StyledTooltipContent>
          <StyledTooltipText>
            Invoiced spend is a beta feature. We are still working to ensure our data and feature
            completeness is at the standard required for a full release. Right now, coverage is most
            complete with key buyers across Central, Local, Healthcare and Blue Light.
          </StyledTooltipText>
          <StyledTooltipText>
            Please reach out to our team if you have any questions or feedback.
          </StyledTooltipText>
        </StyledTooltipContent>
      );
    case "hybridSearch":
      return (
        <StyledTooltipContent>
          <StyledTooltipText>
            You're testing our new Beta notice search. Share your feedback to help shape how it
            works.
          </StyledTooltipText>
        </StyledTooltipContent>
      );
  }
};

type BetaIconProps = {
  betaFeature?: BetaFeatureType;
};

const BetaIcon = ({ betaFeature }: BetaIconProps) => {
  if (!betaFeature) {
    return (
      <BetaIconWrapper>
        <BetaIconText>BETA</BetaIconText>
      </BetaIconWrapper>
    );
  } else {
    return (
      <BetaIconWrapper>
        <TooltipComponent content={betaFeatureContent(betaFeature)}>
          <BetaIconText>BETA</BetaIconText>
        </TooltipComponent>
      </BetaIconWrapper>
    );
  }
};

const BetaIconText = styled.div(({ theme }) => ({
  fontFamily: theme.fontFamily,
  fontSize: "10px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "20px",
  letterSpacing: "0.5px",
  textTransform: "uppercase",
}));

const BetaIconWrapper = styled.div(({ theme }) => ({
  display: "inline-flex",
  height: "20px",
  padding: "0px 6px",
  alignItems: "center",
  gap: "8px",
  backgroundColor: theme.colors.sysBackgroundInverse,
  color: theme.colors.sysTextWhite,
  borderRadius: "4px",
}));

const StyledTooltipContent = styled.div({
  "p:first-of-type": {
    marginTop: 0,
  },
  "p:last-of-type": {
    marginBottom: 0,
  },
});

const StyledTooltipText = styled.p(({ theme }) => ({
  color: theme.colors.sysTextWhite,
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
}));

export default BetaIcon;
